import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=2a3f51a0&scoped=true&"
var script = {}
import style0 from "./LoadingAnimation.vue?vue&type=style&index=0&id=2a3f51a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f51a0",
  null
  
)

export default component.exports